var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignAndCvpDividerBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 28,
    viewBox: "0 0 375 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 181.5,
    y1: 14.25,
    y2: 14.25,
    stroke: "#BFA063",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.793 13.2933C191.183 13.6838 191.184 14.3172 190.793 14.7078L188.207 17.2933C187.817 17.6838 187.184 17.6838 186.793 17.2934L186.048 16.5483L184.208 14.7091C183.817 14.3187 183.817 13.6858 184.207 13.2951L186.791 10.7086C187.182 10.3178 187.815 10.3175 188.206 10.708L190.793 13.2933Z",
    fill: "#BFA063",
    stroke: "#1A1711",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 14,
    r: 5.75,
    stroke: "#BFA063",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375,
    y1: 14.25,
    x2: 193.5,
    y2: 14.25,
    stroke: "#BFA063",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignAndCvpDividerBottom);
export default __webpack_public_path__ + "static/media/campaignAndCvpDividerBottom.7920f2864faf4e9634f22526059a7a81.svg";
export { ForwardRef as ReactComponent };